import type { NavigationGuardNext, Route } from 'vue-router'
import { FEATURE_IDS } from 'src/tpbp-core/feature-flag/featureFlags.const'
import { hasFeature } from 'src/tpbp-core/feature-flag/featureFlags.utils'

export const routeSuitabilityReportPlayground = {
  path: '/suitability-report-playground',
  name: 'suitability-report-playground',
  component: () =>
    import('src/pages/SuitabilityReport/SuitabilityReportPlayground.vue'),
  beforeEnter: (_to: Route, _from: Route, next: NavigationGuardNext) => {
    if (hasFeature(FEATURE_IDS.useSuitabilityReport)) {
      next()
    } else {
      next({ name: 'app' })
    }
  },
}

export const routeSuitabilityReportPdf = {
  path: '/suitability-report-pdf/:studyId?/:signature?',
  name: 'suitability-report-pdf',
  component: () =>
    import('src/pages/SuitabilityReport/SuitabilityReportPdf.vue'),
  meta: {
    isPdf: true,
  },
}
